<!-- prettier-ignore -->

<div class="step-calendar-container">
    <div class="step-calendar-container__title">
        <h1>{{'Fecha de Llegada / Salida' | translate}}</h1>
    </div>

    <div class="step-calendar-container__calendar">
        <mat-card class="register-calendar">
            <mat-calendar #calendar [minDate]="minDate" [(selected)]="selectedDateRange" (selectedChange)="rangeChanged($event)" />
        </mat-card>
    </div>

    @if(false && !registerStandalone){
        <div class="step-calendar-container__timerange">
            <div class="hours-container">
                <h1>{{'Hora llegada' | translate}}</h1>
                <div class="time-range">
                    <ion-select class="ion-select" [(ngModel)]="horaEntrada" (ionChange)="onStartTimeChange($event)">
                        @for(hour of hours; track $index) {
                            <ion-select-option>{{ hour }}</ion-select-option>
                        } 
                    </ion-select>
                </div>
            </div>
        </div>
    }
</div>